import styled, { keyframes } from "styled-components";

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const Spinner = styled.div`
  margin: 16px;
  animation: ${rotate360} 1s linear infinite;
  transform: translateZ(0);
  border-top: 2px solid #a0abde;
  border-right: 2px solid #a0abde;
  border-bottom: 2px solid #a0abde;
  border-left: 4px solid #5467c4;
  background: transparent;
  width: 50px;
  height: 50px;
  border-radius: 50%;
`;
